import { type OpenApiCallReturn, isPaymentRequiredError } from '@tix/openapi-sdk'

import type { CheckoutOrderData, PaidCheckoutCartResult } from '@/components/donations/checkout.types'

/**
 * Maps shopper checkout `OpenApiCallReturn` to the Stripe two-stage result shape. `requires_action` is the 402 `intent_requires_action` branch (Stripe `client_secret` in `_extra`).
 */
export function mapCheckoutResponse(response: OpenApiCallReturn<CheckoutOrderData>): PaidCheckoutCartResult {
  if (response.status === 'success' && response.data) {
    return { status: 'completed', data: response.data }
  }

  const { error } = response
  if (isPaymentRequiredError(error)) {
    const clientSecret = error.intentRequiresActionExtra?.client_secret

    if (clientSecret) {
      return { status: 'requires_action', client_secret: clientSecret }
    }
  }

  return { status: 'error', error: error ?? new Error('Checkout failed') }
}
